var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"zoom"}},[_c('div',{staticClass:"invite"},[_c('div',{attrs:{"id":"canvasPic2"}},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})]),_c('div',{staticClass:"bottom"},[_vm._v("长按图片或者扫描二维码分享")])])])}
var staticRenderFns = []

export { render, staticRenderFns }